import { useMutation } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { useAuth } from "../helper/useAuth";

export interface ICancelPendingPlanChangeResponse {
  message: string;
}

export const useCancelPendingPlanChange = () => {
  const { refreshUser } = useAuth();

  return useMutation<ICancelPendingPlanChangeResponse, Error, void>({
    mutationFn: async () =>
      httpService.post<ICancelPendingPlanChangeResponse>(
        API_CONFIG.path.stripeCancelPendingChange,
        {}
      ),
    onSuccess: () => {
      refreshUser();
    },
  });
};
